/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

// Timeline context
import { TimelineProvider } from "template/examples/Timeline/context";
import { Tooltip } from "@mui/material";

function TimelineList({ title, subtitle, dark = false, children }) {
  return (
    <TimelineProvider value={dark} sx={{ height: '100%' }}>
      <Card sx={{ height: '100%' }}>
        <SoftBox bgColor={dark ? "dark" : "white"} variant="gradient">
          <SoftBox pt={3} px={3}>
            <SoftBox display='flex' flexDirection='row'>
              <SoftTypography pr={1} variant="h6" fontWeight="medium" color={dark ? "white" : "dark"}>
                {title}
              </SoftTypography>
              <Tooltip title="The next event coming up for this group." placement="right">
                <HelpOutlineIcon fontSize="small" />
              </Tooltip>
            </SoftBox>
            <SoftTypography variant="h6" fontWeight="light" color={dark ? "white" : "dark"}>
              As of {subtitle}
            </SoftTypography>
          </SoftBox>
          <SoftBox p={0}>{children}</SoftBox>
        </SoftBox>
      </Card>
    </TimelineProvider>
  );
}

// Typechecking props for the TimelineList
TimelineList.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  dark: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default TimelineList;
